import VerticalImageNContent from '@/components/ContextPrinter/VerticalImageNContent';

interface IProps {
    text: string;
    image?: string;
}

function ListEmpty({ text, image }: IProps) {
    return (
        <VerticalImageNContent
            containerStyle={{ paddingTop: '60px' }}
            content={text}
            image={image ? image : '/img/common/img_search_wait@3x.png'}
            imageWidth={92}
            imageHeight={92}
        />
    );
}

export default ListEmpty;
